import { t } from '@hefe/i18n';
import { Inventory, RequestBasePostInventory } from '@hefe/models';
import { InventoryApi, InventorySlice, ModalsSlice } from '@hefe/store';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';
import { inventoryNavigationTreeDataSelectOptions } from '../../services/inventory.service';

interface AddEditInventoryFormProps {
  inventory?: Inventory;
}

export default function AddEditInventoryForm(props: AddEditInventoryFormProps) {
  const { inventory } = props;

  const activeCategoryId = useSelector(InventorySlice.selectedKeySelector);

  const { data: navigation = [] } = InventoryApi.useFetchNavigationQuery();

  const [saveInventory] = InventoryApi.useSaveInventoryMutation();

  const dispatch = useAppDispatch();
  const modalState = useSelector(ModalsSlice.modalsState);

  const onSubmit = (values: any, resetForm: any) => {
    const closeModal = ModalsSlice.modalsActions.closeModal;
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;

    const request: RequestBasePostInventory = {
      ...values,
      ...(inventory ? { id: inventory.id } : {}),
      ...(values.category !== 'uncategorized'
        ? { category_id: values.category }
        : { category_id: null }),
    };

    dispatch(setModalLoading(true));
    saveInventory({
      request: request,
      oldCategoryId: inventory?.category_id,
    })
      .unwrap()
      .then(() => {
        resetForm();
        dispatch(closeModal());
      })
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  return (
    <CustomForm
      key={`add-edit-inventory-form-${
        inventory
          ? inventory.id + inventory.name + inventory.category_id
          : 'new' + activeCategoryId
      }`}
      formId={`add-edit-inventory-form-${inventory ? inventory.id : 'new'}`}
      fields={[
        {
          name: 'name',
          label: t('inventory.details.name'),
          type: 'text',
          initalValue: inventory?.name,
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'description',
          label: t('inventory.details.description'),
          type: 'text',
          initalValue: inventory?.description,
          rules: [],
        },
        {
          name: 'category',
          label: t('inventory.details.category'),
          type: 'tree_select',
          initalValue: inventory?.category_id || activeCategoryId,
          selectOptions: inventoryNavigationTreeDataSelectOptions(navigation),
          rules: [],
        },
      ]}
      loading={modalState.modal.loading}
      onSubmit={onSubmit}
    />
  );
}
